import { useState, useCallback } from "react";
import type { Web3LoginSupportedType } from "@/src/features/auth/compat/sdk-types";

/** 与 LoginGuide 弹窗内逻辑一致；原类型定义在已移除的 AgentGuidePopup 中 */
export interface UseLoginGuideContentReturn {
  termsAccepted: boolean;
  onTermsChange: () => void;
  reset: () => void;
  subLoginType: Web3LoginSupportedType | undefined;
  setSubLoginType: (type: Web3LoginSupportedType | undefined) => void;
}

/**
 * LoginGuideContent 业务逻辑 Hook
 *
 * 负责管理登录引导内容组件的状态和业务逻辑
 * 包括条款同意状态管理、登录处理等功能
 *
 * @param onLogin 登录按钮点击回调函数
 * @param onTermsChange 条款同意状态变化回调函数
 * @returns Hook 返回值，包含状态和处理函数
 */
export const useLoginGuideContent = (): UseLoginGuideContentReturn => {
  // 使用外部状态或内部状态
  const [termsAccepted, setTermsAccepted] = useState(true);
  const [subLoginType, setSubLoginType] = useState<
    Web3LoginSupportedType | undefined
  >(undefined);

  /**
   * 设置条款同意状态
   */
  const onTermsChange = useCallback(() => {
    setTermsAccepted?.(!termsAccepted);
  }, [setTermsAccepted, termsAccepted]);

  /**
   * 重置组件状态
   */
  const reset = useCallback(() => {
    setTermsAccepted(false);
  }, [setTermsAccepted]);

  return {
    termsAccepted,
    onTermsChange,
    reset,
    subLoginType,
    setSubLoginType,
  };
};
